import { FormGroup } from '@angular/forms';
import { FormFieldsGeneratorService } from './../customer-form/form-helpers/form-fields-generator.service';
import { Injectable } from '@angular/core';
import { UserDataFormService } from '../customer-form/user-data/user-data-form.service';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';
import { CommonModalService } from '../utils/modals/common-modal.service';

@Injectable({
  providedIn: 'root'
})
export class ProvinceSelectModalService {
  private selectedProvince: string;

  constructor(private commonModalService: CommonModalService,
              private userDataFormService: UserDataFormService,
              private formsGenerator: FormFieldsGeneratorService) {}

  openProvinceSelectModal(formGroupName?: string): void  {
    const formGroup = this.formsGenerator.activeForm.get(formGroupName) as FormGroup;

    const provinces: string[] = [
      'dolnośląskie', 'kujawsko-pomorskie', 'lubelskie', 'lubuskie',
      'łódzkie', 'małopolskie', 'mazowieckie', 'opolskie', 'podkarpackie',
      'podlaskie', 'pomorskie', 'śląskie', 'świętokrzyskie', 'warmińsko-mazurskie',
      'wielkopolskie', 'zachodniopomorskie'
    ];

    const modalData = {
      templateName: CommonModalTemplatesEnum.PROVINCE_SELECT,
      provincesList: provinces,
      selectedProvince: this.selectedProvince || provinces[0],
      selectProvince: (event: Event) => {
        event.preventDefault();
        this.selectedProvince = modalData.selectedProvince;

        formGroup.controls.province.setValue(this.selectedProvince);
        formGroup.controls.province.markAsTouched();
        formGroup.controls.province.updateValueAndValidity();
        this.updateFormState(formGroupName);

        this.commonModalService.removeModal(CommonModalTemplatesEnum.PROVINCE_SELECT);
      }
    };

    this.commonModalService.setData(modalData);
  }

  clearProvince(formGroupName?: string): void {
    const formGroup = this.formsGenerator.activeForm.get(formGroupName) as FormGroup;

    formGroup.controls.province.setValue('');
    formGroup.controls.province.markAsTouched();
    formGroup.controls.province.updateValueAndValidity();

    this.updateFormState(formGroupName);
  }

  updateFormState(formGroupName?: string): void {

    switch (formGroupName) {
      case 'contractAddress':
        this.userDataFormService.onContractAddressChange();
        break;
      case 'deliveryAddress':
        this.userDataFormService.onOtherDeliveryAddressInputChange();
        break;
      case 'correspondenceAddress':
        this.userDataFormService.onOtherCorrespondenceAddressInputChange();
        break;
      case 'installationAddress':
        this.userDataFormService.onOtherInstallationAddressInputChange();
        break;
    }
  }
}
